import { isEmptyValue } from '../managerUtils';

// activeFilters entries shape: { [matchMode]: value }. Empty values (e.g.
// reference filterFirst defaults with no selection) serialize as
// `filter[name][matchMode]=` which the API rejects with 500 — strip them so
// fetchDatasetData never sends empty filter constraints.
export const stripEmptyActiveFilters = (
  activeFilters: Record<string, any>
): Record<string, any> => {
  const result: Record<string, any> = {};
  Object.keys(activeFilters).forEach((key) => {
    const filter = activeFilters[key];
    const [value] = Object.values(filter ?? {});
    if (isEmptyValue(value)) return;
    result[key] = filter;
  });
  return result;
};
